import React from "react";
import { useAuth } from "../contexts/AuthContext";
import LoadingIndicator from "./LoadingIndicator";

interface AppBootstrapperProps {
  children: React.ReactNode;
}

export default function AppBootstrapper({ children }: AppBootstrapperProps) {
  const { loading } = useAuth();

  // Show loading only while AuthContext is determining initial auth state
  if (loading) {
    return <LoadingIndicator />;
  }

  // Let the route guards handle all auth and onboarding logic
  // OAuth token capture is now handled in AuthCallback.tsx
  return <>{children}</>;
}
